"use client";

import { c as _c } from "react/compiler-runtime";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import NotificationDrop from "./NotificationDrop";
import NotificationHeader from "./NotificationHeader";
import NotificationTimestamp from "./NotificationTimestamp";
import { getIsDirectMessage, useWaveNavigation } from "../utils/navigationUtils";
interface NotificationWithDropProps {
  readonly drop: ApiDrop;
  readonly actionText: string;
  readonly createdAt: number;
  readonly activeDrop: ActiveDropState | null;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
}
export default function NotificationWithDrop(t0) {
  const $ = _c(38);
  const {
    drop,
    actionText,
    createdAt,
    activeDrop,
    onReply,
    onDropContentClick
  } = t0;
  const {
    createReplyClickHandler,
    createQuoteClickHandler
  } = useWaveNavigation();
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== actionText || $[1] !== activeDrop || $[2] !== createQuoteClickHandler || $[3] !== createReplyClickHandler || $[4] !== createdAt || $[5] !== drop || $[6] !== onReply) {
    const isDirectMessage = getIsDirectMessage(drop.wave);
    t6 = "tw-flex tw-w-full tw-flex-col tw-space-y-2";
    let t8;
    if ($[15] !== drop.author) {
      t8 = <NotificationsFollowBtn profile={drop.author} size={UserFollowBtnSize.SMALL} />;
      $[15] = drop.author;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== actionText) {
      t9 = <span className="tw-text-sm tw-font-normal tw-text-iron-400">{actionText}</span>;
      $[17] = actionText;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== createdAt) {
      t10 = <NotificationTimestamp createdAt={createdAt} />;
      $[19] = createdAt;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    if ($[21] !== drop.author || $[22] !== t10 || $[23] !== t8 || $[24] !== t9) {
      t7 = <NotificationHeader author={drop.author} actions={t8}>{t9}{t10}</NotificationHeader>;
      $[21] = drop.author;
      $[22] = t10;
      $[23] = t8;
      $[24] = t9;
      $[25] = t7;
    } else {
      t7 = $[25];
    }
    T0 = NotificationDrop;
    t1 = drop;
    t2 = activeDrop;
    t3 = onReply;
    t4 = createReplyClickHandler(drop.wave.id, isDirectMessage);
    t5 = createQuoteClickHandler(isDirectMessage);
    $[0] = actionText;
    $[1] = activeDrop;
    $[2] = createQuoteClickHandler;
    $[3] = createReplyClickHandler;
    $[4] = createdAt;
    $[5] = drop;
    $[6] = onReply;
    $[7] = T0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    T0 = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[26] !== T0 || $[27] !== onDropContentClick || $[28] !== t1 || $[29] !== t2 || $[30] !== t3 || $[31] !== t4 || $[32] !== t5) {
    t8 = <T0 drop={t1} activeDrop={t2} onReply={t3} onReplyClick={t4} onQuoteClick={t5} onDropContentClick={onDropContentClick} />;
    $[26] = T0;
    $[27] = onDropContentClick;
    $[28] = t1;
    $[29] = t2;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== t6 || $[35] !== t7 || $[36] !== t8) {
    t9 = <div className={t6}>{t7}{t8}</div>;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  return t9;
}